/**
 * Eksporti i regjistrit të aseteve — një përkufizim kolonash, tre formate.
 *
 * Kolonat shkruhen NJË herë: `printReport` (PDF/printim) dhe CSV-ja e lexojnë
 * të njëjtën listë. Kur eksporti kishte kolonat e veta faqe-më-faqe, PDF-ja dhe
 * Excel-i ktheheshin me kolona të ndryshme për të njëjtën tabelë.
 */

import { printReport } from './pdfPrint';
import { categoryLabel, statusLabel, conditionLabel, dateText } from '../config/assets';

export const ASSET_COLUMNS = [
  { label: 'Kodi',        key: 'assetCode',  width: '9%' },
  { label: 'Aseti',       key: 'name',       width: '18%' },
  { label: 'Kategoria',   key: 'category',   width: '10%' },
  { label: 'Marka/Modeli', key: 'device',    width: '14%' },
  { label: 'Nr. serik',   key: 'serial',     width: '12%' },
  { label: 'Statusi',     key: 'status',     width: '10%' },
  { label: 'Gjendja',     key: 'condition',  width: '9%' },
  { label: 'Mbajtësi',    key: 'holder',     width: '13%' },
  { label: 'Vlera',       key: 'value',      width: '9%', align: 'right' },
];

/** Rreshtat në formën që lexon eksporti — etiketa njerëzore, jo çelësa. */
export function assetRows(assets = []) {
  return assets.map((a) => ({
    assetCode: a.assetCode || '',
    name:      a.name || '',
    category:  categoryLabel(a.category),
    device:    [a.brand, a.model].filter(Boolean).join(' ') || '—',
    serial:    a.serialNumber || '—',
    status:    statusLabel(a.status),
    condition: conditionLabel(a.condition),
    // Mungesa e mbajtësit lexohet si mungesë, jo si bosh i pashpjegueshëm.
    holder:    a.holder?.name || (a.status === 'assigned' ? 'Punëtor i fshirë' : '—'),
    value:     a.purchaseValue === null || a.purchaseValue === undefined
      ? '—'
      : `${Number(a.purchaseValue).toFixed(2)} ${a.currency || 'EUR'}`,
    warranty:  dateText(a.warrantyUntil),
  }));
}

const FILE_BASE = 'regjistri-i-aseteve';

export function printAssets(assets, { company = '', filters = [] } = {}) {
  printReport({
    title:      'Regjistri i Aseteve',
    subtitle:   'Pajisjet e kompanisë dhe mbajtësit e tyre',
    company,
    orientation: 'landscape',
    columns:    ASSET_COLUMNS,
    rows:       assetRows(assets),
    extraInfo:  filters,
    filename:   FILE_BASE,
  });
}

/** CSV me BOM — pa të, Excel-i i lexon shkronjat shqipe si simbole. */
export function assetsCsv(assets) {
  const rows = assetRows(assets);
  const esc = (v) => `"${String(v ?? '').replace(/"/g, '""')}"`;
  const head = ASSET_COLUMNS.map((c) => esc(c.label)).join(',');
  const body = rows.map((r) => ASSET_COLUMNS.map((c) => esc(r[c.key])).join(',')).join('\n');
  return `﻿${head}\n${body}`;
}

export function downloadAssetsCsv(assets) {
  const blob = new Blob([assetsCsv(assets)], { type: 'text/csv;charset=utf-8;' });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement('a');
  a.href = url;
  a.download = `${FILE_BASE}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
